"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { ArrowUp, Instagram, Linkedin, Twitter } from "lucide-react";
function FooterNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  const services = ["IV Therapy Infusions", "HydraFacial Boosters", "Immune & Energy Boost", "Skin Vitality Treatments", "Wellness Consultations"];
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-3 gap-12 w-full max-w-5xl mx-auto text-center md:text-left">
        {[1, 2, 3].map(i => <div key={i} data-index={i} className="flex flex-col space-y-6 items-center md:items-start">
            <div className="h-6 w-32 bg-muted/20 animate-pulse rounded-md" />
            <div className="space-y-3 w-full flex flex-col items-center md:items-start">
              {[1, 2, 3, 4].map(j => <div key={j} data-index={j} className="h-4 w-40 bg-muted/20 animate-pulse rounded-md" />)}
            </div>
          </div>)}
      </div>;
  }
  const hasColumns = menuItems.some(item => item.children && item.children.length > 0);
  if (hasColumns) {
    return <div className="grid grid-cols-1 md:grid-cols-3 gap-12 w-full max-w-5xl mx-auto text-center md:text-left">
        {menuItems.slice(0, 3).map((col, i) => <div key={col.id} data-index={i} className="flex flex-col space-y-6">
            <h4 className="font-default font-semibold text-primary tracking-widest uppercase text-xs">{col.label}</h4>
            <ul className="flex flex-col space-y-3">
              {col.children?.map((link, j) => <li key={link.id} data-index={j}>
                  <Link to={link.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>)}
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-12 w-full max-w-5xl mx-auto text-center md:text-left">
      {}
      <div className="flex flex-col space-y-6">
        <h4 className="font-default font-semibold text-primary tracking-widest uppercase text-xs">Services</h4>
        <ul className="flex flex-col space-y-3">
          {services.map((service, i) => <li key={i} data-index={i}>
              <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
                {service}
              </Link>
            </li>)}
        </ul>
      </div>

      {}
      <div className="flex flex-col space-y-6">
        <h4 className="font-default font-semibold text-primary tracking-widest uppercase text-xs">Company</h4>
        <ul className="flex flex-col space-y-3">
          {menuItems.length > 0 ? menuItems.slice(0, 5).map((link, i) => <li key={link.id} data-index={i}>
                <Link to={link.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
                  {link.label}
                </Link>
              </li>) : <>
              <li data-index={0}><Link to="/HomePage" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">Home</Link></li>
              <li data-index={1}><Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">Services</Link></li>
              <li data-index={2}><Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">About Us</Link></li>
              <li data-index={3}><Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">Contact</Link></li>
            </>}
        </ul>
      </div>

      {}
      <div className="flex flex-col space-y-6">
        <h4 className="font-default font-semibold text-primary tracking-widest uppercase text-xs">Legal</h4>
        <ul className="flex flex-col space-y-3">
          <li data-index={0}><Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">Terms & Conditions</Link></li>
          <li data-index={1}><Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">Privacy Policy</Link></li>
          <li data-index={2}><Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">Legal Notice</Link></li>
          <li data-index={3}><Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">Cookies</Link></li>
        </ul>
      </div>
    </div>;
}
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  return <section data-section-id="246203" id="footer" className="pt-20 pb-8 border-t border-border/30 dark bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {}
        <div className="flex justify-center mb-16">
          <Link to="/" className="inline-block transition-opacity hover:opacity-80">
            <img src="https://shifahydrationlounge.com/wp-content/uploads/2026/05/cropped-cropped-cropped-IMG_8807.jpg" data-wvc-srcset="/img/al_shifa_logo_gold.png-wvc-srcset" data-wvc-sizes="/img/al_shifa_logo_gold.png-wvc-sizes" alt="Al Shifa Hydration Lounge" className="h-12 w-auto" loading="lazy" />
          </Link>
        </div>

        {}
        <MenuProvider menu_id="footer_menu">
          <FooterNavigation />
        </MenuProvider>

        {}
        <div className="mt-20 pt-8 border-t border-border/20 flex flex-col md:flex-row items-center justify-between gap-6">
          
          {}
          <div className="flex items-center gap-5 order-2 md:order-1">
            <Link to="#" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Twitter">
              <Twitter className="size-5" strokeWidth={1.5} />
            </Link>
            <Link to="#" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Instagram">
              <Instagram className="size-5" strokeWidth={1.5} />
            </Link>
            <Link to="#" className="text-muted-foreground hover:text-primary transition-colors" aria-label="LinkedIn">
              <Linkedin className="size-5" strokeWidth={1.5} />
            </Link>
          </div>

          {}
          <div className="order-3 md:order-2 text-center">
            <p className="text-sm text-muted-foreground font-default">© 2026&nbsp;Shifa Hydration Lounge PLLC. All rights reserved.</p>
          </div>

          {}
          <div className="order-1 md:order-3">
            <Button variant="outline" size="icon" onClick={scrollToTop} className="rounded-lg size-10 border-primary/30 text-primary hover:bg-primary hover:text-primary-foreground transition-all shadow-sm" aria-label="Volver arriba">
              <ArrowUp className="size-4" strokeWidth={2} />
            </Button>
          </div>

        </div>
      </div>
    </section>;
}